<rask-violversion-selector [kontrakt]="kontrakt" [disabled]="!canEditViolVersion()" (violVersionChanged)="onViolVersionChanged($event)"></rask-violversion-selector>
@if (!kontrakt.kontraktKopieratFranId && !kontrakt.viol3 && hasVirkesekonomiadministrera()) {
  <rask-action-button (click)="copyKontraktClick()" icon="far fa-copy" [disabled]="!canCopy()">Skapa Kopia Viol3</rask-action-button>
}

@if (kontrakt.kontraktKopieratFranId) {
  <rask-textmultiline label="Kontrakt kopierat från">
    <a
      [routerLink]="[]"
      [queryParams]="{ kontraktId: kontrakt.kontraktKopieratFranId}">
      {{ getRelateratKontraktNamn() }}
    </a>
  </rask-textmultiline>
}
@if (kontrakt?.relateradeKontrakt?.length > 0) {
  <rask-textmultiline label="Kontrakt kopierat till">
    @for (relateratKontrakt of kontrakt.relateradeKontrakt; track relateratKontrakt) {
      <span>
        <a
          [routerLink]="[]"
          [queryParams]="{ kontraktId: relateratKontrakt.id}">
          {{ relateratKontrakt.kontraktnummer }} - {{relateratKontrakt.benamning}}
        </a>
        <br>
        </span>
      }
    </rask-textmultiline>
  }

